import { AccountStatus, type AccountStatusValue } from '../../auth/api/auth';

export function isPendingAccountStatus(status: unknown): boolean {
  return (
    status === AccountStatus.Pending
    || status === 'Pending'
    || status === 'pending'
    || status === 0
    || status === '0'
  );
}

export function isActiveAccountStatus(status: unknown): boolean {
  return (
    status === AccountStatus.Active
    || status === 'Active'
    || status === 'active'
    || status === 1
    || status === '1'
  );
}

export function accountStatusLabel(status: unknown): string {
  if (isPendingAccountStatus(status)) {
    return 'Pending';
  }
  if (isActiveAccountStatus(status)) {
    return 'Active';
  }
  return 'Unknown';
}

export function accountStatusTagColor(status: unknown): 'orange' | 'green' | 'default' {
  if (isPendingAccountStatus(status)) {
    return 'orange';
  }
  if (isActiveAccountStatus(status)) {
    return 'green';
  }
  return 'default';
}

export type { AccountStatusValue };
